"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _StatelessPanel = _interopRequireDefault(require("@insided/deprecated-control/panel/StatelessPanel"));

var _Message = require("@insided/deprecated-control/ui-components/Message");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _ZapTemplateCard = require("../zapier/ZapTemplateCard");

var _constants = require("@insided/shared/constants");

var IntegrationByZapier = function IntegrationByZapier(_ref) {
  var isInstalled = _ref.isInstalled;
  var link = 'https://zapier.com/app/editor/template/550270';
  var title = "Send Intercom messages with updated moderator tags to ".concat(_constants.PLATFORM_BRAND_NAME, " topics");
  return (0, _preact.h)("div", {
    className: "intercom-by-zapier"
  }, !isInstalled && (0, _preact.h)("div", {
    className: "intercom-by-zapier-title"
  }, (0, _preact.h)("span", null, "Integration(s) by "), ' ', (0, _preact.h)(_assets.default, {
    width: 56,
    height: 26,
    icon: "zapier",
    customClass: "intercom-by-zapier-icon"
  })), !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "No installation required for Zapier integration(s).",
    fullWidth: true
  }), (0, _preact.h)(_StatelessPanel.default, {
    customClass: "integration__panel zap-panel",
    title: (0, _preact.h)(_IntegrationPanelItems.IntegrationPanelHeaderWithImages, {
      title: title,
      imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
      imageToName: "intercom-s",
      customClass: "zap-link",
      meta: (0, _preact.h)(_Button.default, {
        size: "medium",
        title: "Use this Zap",
        onClick: function onClick() {
          (0, _ZapTemplateCard.zapTemplateClicked)(title, link, 'Zapier app page'); // @ts-expect-error

          window.open(link, '_blank').focus();
        },
        className: "qa-zap-link"
      })
    })
  }));
};

var _default = IntegrationByZapier;
exports.default = _default;